module.exports = __webpack_public_path__ + "img/beef-stroganoff.f03a1074.jpg";